import styled from 'styled-components';
import { IAccountProfile } from '../../interface/user';
import { MailOutline } from '../icons';

const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 12px 10px;
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  background-color: var(--clr-field-disabled);
  color: var(--clr-title);
  font-size: 13px;
  line-height: 20px;
  width: 100%;

  .icon {
    color: var(--clr-general-description);
    font-size: 18px;
    flex-shrink: 0;
  }

  .email {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const LoggedUser = ({ user }: { user: IAccountProfile }) => {
  if (!user) return null;
  return (
    <UserWrapper>
      <MailOutline />
      <span className="email">{user?.email ?? ''}</span>
    </UserWrapper>
  );
};

export default LoggedUser;
